import numeral from 'numeral';

/**
 * Format a number as a string value to display as a metric. Numbers >= 1000 will
 * be displayed with commas, e.g. 15000 will be formatted as '15,000'.
 */
const formatPreciseNumber = (value: number) => numeral(value).format('0,0');

export default formatPreciseNumber;
